import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_56: FaireProductEntity = {
  token: "legacy_prod_abbott-56",
  type: "product",
  name: "Set of 4 Wood Handle Cheese Knives",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/33b144bf1b9ad191fe61491a9b6d4783902dfc24968350c684259df0bcfbfcf9.jpeg",
  priceDollars: 32,
  subcategory: "Scissors & Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
